import {
  registerCookieEvents,
  registerConsentWrappers,
} from "@heyhabito/cookie-consent"
import { loadGoogleTagManager } from "@heyhabito/google-tag-manager"

// Intended to be used for convenience in every top-level, public frontend.
export const alwaysInclude = (gtmAppId: string): void => {
  registerConsentWrappers()
  registerCookieEvents()
  loadGoogleTagManager(gtmAppId)
}
